import { z } from 'zod';

import { ACCOUNT_TYPE } from '../../util/constants';
import { createApi } from '../core';
import { AccountDetails } from '../types/account';

export type UpdateCustomerParams = {
  customerType: (typeof ACCOUNT_TYPE)[keyof typeof ACCOUNT_TYPE];
  email: string;
  customerId?: string; // --this will be the SFID of either the lead or account
  customerNumber?: string; // --this will be the customer Id of the Cognito Account
  mobilePhone?: string;
  firstname?: string;
  lastname?: string;
  studentFirstName?: string;
  studentLastName?: string;
  curriculum?: string;
  yearLevel?: string;
  schoolId?: string; // --this will be the SFId of the school account
  recordType?: string; // --valid values are “Student”, “Parent / Guardian”
  countryCode?: string;
  postCode?: string;
  leadSource?: string;
};

type UpdateAccountParams = {
  firstName: string;
  lastName: string;
  email: string;
  phone?: string;
};

export const accountApi = createApi.group(['account'], (createKey) => {
  const detailsQueryConfig = {
    queryKey: createKey(['details']),
    queryFn: () => {
      return createApi.fetch({
        path: ['account', 'details'],
        method: 'GET',
        basePath: 'portalAPI',
        sign: true,
        validator: AccountDetails,
      });
    },
    staleTime: createApi.time(1, 'hours'),
    refetchInterval: createApi.time(2, 'hours'),
    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
    retry: 25,
    retryDelay: 1500,
  };

  return {
    details: createApi.query(detailsQueryConfig),
    timezone: createApi.query({
      queryKey: createKey(['details']),
      queryFn: () => {
        return createApi.fetch({
          path: ['account', 'details'],
          method: 'GET',
          basePath: 'portalAPI',
          sign: true,
          validator: AccountDetails,
        });
      },
      staleTime: createApi.time(1, 'hours'),
      refetchInterval: createApi.time(2, 'hours'),
      refetchOnMount: false,
      refetchOnReconnect: false,
      refetchOnWindowFocus: false,
    }),
    update: createApi.mutation({
      mutationFn: async (params: Partial<UpdateCustomerParams>) => {
        return createApi.fetch({
          path: ['customer', 'details'],
          method: 'PUT',
          body: params,
          validator: z.unknown(),
          basePath: 'portalAPI',
          sign: true,
        });
      },
    }),
    update_legacy: createApi.mutation({
      mutationFn: (params: UpdateAccountParams) => {
        return createApi.fetch({
          path: ['account', 'details'],
          method: 'PUT',
          body: params,
          validator: z.unknown(),
          basePath: 'portalAPI',
          sign: true,
        });
      },
    }),
  };
});
